module.exports = __webpack_public_path__ + "static/img/2018120504.9e75096.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/2018120504.jpg
// module id = /a5R
// module chunks = 1